/**
 * Logique PURE de la garde « accord parental » (RGPD art.8), testable sans React.
 *
 * Un élève < 15 ans dont le consentement n'est pas `active` ne doit pas accéder
 * à l'application : on lui montre l'écran d'attente jusqu'à validation du parent.
 */

export interface ConsentFields {
  parental_consent_required: boolean | null;
  parental_consent_status: string | null;
  parental_consent_email: string | null;
}

/**
 * Vrai si l'accès doit être bloqué : consentement requis ET pas encore `active`
 * (couvre `pending` et `revoked`).
 */
export function isConsentBlocked(fields: ConsentFields | null | undefined): boolean {
  if (!fields) return false;
  return fields.parental_consent_required === true && fields.parental_consent_status !== 'active';
}

/** Email du parent à afficher sur l'écran d'attente (fallback générique). */
export function consentParentEmail(fields: ConsentFields | null | undefined): string {
  return fields?.parental_consent_email?.trim() || 'ton parent';
}
